module.exports = __webpack_public_path__ + "img/fitt_framework.2b4de686.svg";